import { RIDE_ACT, RIDE_DEL, RIDE_DET, RIDE_ENABLE, RIDE_LIST, RIDE_LIST_PARC, RIDE_QUEUE, RIDE_SAVE } from "../actions/action-types";
import { initialStateDatasArray, initialSTateDatasData, initialStateNext } from "../helpers";

// Liste des attractions
export function ListRidesReducer(state = initialStateDatasArray, action) {
    switch(action.type) {
        case RIDE_LIST:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Liste des attractions par parc
export function ListRidesParcReducer(state = initialStateDatasArray, action) {
    switch(action.type) {
        case RIDE_LIST_PARC:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Liste des attractions actives par parc
export function ListRideActReducer(state = initialStateDatasArray, action) {
    switch (action.type) {
        case RIDE_ACT:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Détails d'une attraction
export function DetailsRideReducer(state = initialSTateDatasData, action) {
    switch(action.type) {
        case RIDE_DET:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Détails d'une attraction pour queue time
export function DetailsRideQueueReducer(state = initialSTateDatasData, action) {
    switch(action.type) {
        case RIDE_QUEUE:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Sauvegarde d'une attraction
export function SaveRideReducer(state = initialStateNext, action) {
    switch(action.type) {
        case RIDE_SAVE:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Suppression d'une attraction
export function DeleteRideReducer(state = initialStateNext, action) {
    switch(action.type) {
        case RIDE_DEL:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Activation/désactivation d'une attraction
export function SetEnableRideReducer(state = initialStateNext, action) {
    switch (action.type) {
        case RIDE_ENABLE:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}